var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_85)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 20.6667C25 17.9052 22.7614 15.6667 20 15.6667C17.2386 15.6667 15 17.9052 15 20.6667C15 23.4281 17.2386 25.6667 20 25.6667C22.7614 25.6667 25 23.4281 25 20.6667Z",
    stroke: "#F8635E",
    strokeWidth: 3.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6667 20.6667C31.6667 14.2233 26.4433 9 20 9C13.5567 9 8.33334 14.2233 8.33334 20.6667C8.33334 27.11 13.5567 32.3333 20 32.3333C26.4433 32.3333 31.6667 27.11 31.6667 20.6667Z",
    stroke: "#FA9793",
    strokeWidth: 3.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66666 1.66667H18.3333C29.379 1.66667 38.3333 10.621 38.3333 21.6667V38.3333H20C9.87476 38.3333 1.66666 30.1252 1.66666 20V1.66667Z",
    stroke: "#F8635E",
    strokeWidth: 3.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 30H0V40H40V30Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_85"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0c0094e010d837271e4252305d6f6777.svg";
export { ForwardRef as ReactComponent };